const formatBarcode = (event) => {
  const target = event.target;
  target.value = target.value.toUpperCase();
};

document
  .querySelectorAll("input[id$=_barcode]")
  .forEach(($input) => $input.addEventListener("input", formatBarcode));
